
























import { PaginationQueryStringMixin } from '@/features/core/components/mixins/pagination-query-string';
import { SpotTableFilterMixin } from '@/features/core/components/mixins/spot-table-filter';
import TreeNodeLocationGeneratorMixin from '@/features/core/components/mixins/tree-node-location-generator';
import { RootGetter } from '@/features/core/store';
import { SpotTableSpot } from '@/features/domain-ui/spot-table/model';
import { SpotsExportSpot } from '@/features/domain-ui/spots-export/model';
import { isDef } from '@/util/lang';
import { ApolloQueryResult } from 'apollo-client';
import { Component, Mixins } from 'vue-property-decorator';
import exportSubscription from './export.gql';
import spotsQuery from './spots.gql';
import query from './view.gql';
import {
  AppManagerAppSpotsViewExportSubscription,
  AppManagerAppSpotsViewExportSubscriptionVariables,
} from './__generated__/AppManagerAppSpotsViewExportSubscription';
import {
  AppManagerAppSpotsViewQuery,
  AppManagerAppSpotsViewQueryVariables,
} from './__generated__/AppManagerAppSpotsViewQuery';
import {
  AppManagerAppSpotsViewSpotsQuery,
  AppManagerAppSpotsViewSpotsQueryVariables,
} from './__generated__/AppManagerAppSpotsViewSpotsQuery';

@Component({
  apollo: {
    roles: {
      query,
      pollInterval: 60000,
      variables(this: SpotsView): AppManagerAppSpotsViewQueryVariables {
        return { roles: this.roles, healths: this.healths, manufacturers: this.manufacturers };
      },
      manual: true,
      result(this: SpotsView, result: ApolloQueryResult<AppManagerAppSpotsViewQuery>): void {
        this.empty = result.data.spots.count === 0;
        this.roleAggregations = result.data.roles.roleAggregations;
        this.healthAggregations = result.data.healths.healthAggregations;
        this.manufacturerAggregations = result.data.manufacturers.manufacturerAggregations;
      },
    },
    spots: {
      query: spotsQuery,
      pollInterval: 60000,
      variables(this: SpotsView): AppManagerAppSpotsViewSpotsQueryVariables {
        return { ...this.variables, skip: this.skip, take: this.take };
      },
    },
  },
  data() {
    return {
      empty: false,
      roleAggregations: undefined,
      healthAggregations: undefined,
      manufacturerAggregations: undefined,
      spots: undefined,
    };
  },
})
export default class SpotsView extends Mixins(
  TreeNodeLocationGeneratorMixin,
  PaginationQueryStringMixin,
  SpotTableFilterMixin,
) {
  private empty!: boolean;
  private roleAggregations?: AppManagerAppSpotsViewQuery['roles']['roleAggregations'];
  private healthAggregations?: AppManagerAppSpotsViewQuery['healths']['healthAggregations'];
  private manufacturerAggregations?: AppManagerAppSpotsViewQuery['manufacturers']['manufacturerAggregations'];
  private readonly spots?: AppManagerAppSpotsViewSpotsQuery['spots'];

  @RootGetter
  private readonly userId?: string;

  protected get count(): number {
    return this.spots?.count ?? 0;
  }

  private get variables(): AppManagerAppSpotsViewExportSubscriptionVariables {
    return {
      roles: this.roles,
      healths: this.healths,
      manufacturers: this.manufacturers,
      descriptors: [{ start: '-P30D', stop: this.normalizedMetricsStopDate }],
      userId: this.userId,
    };
  }

  private onSpotClick(spot: SpotTableSpot): void {
    this.$router.push({
      name: 'AppManager/TreeNode/Spots/Spot',
      params: { treeNodeId: spot.path.items.slice(-1)[0].id, spotId: spot.id },
    });
  }

  private exportSpots(): Promise<SpotsExportSpot[]> {
    return new Promise((resolve) => {
      this.$apollo
        .subscribe<AppManagerAppSpotsViewExportSubscription, AppManagerAppSpotsViewExportSubscriptionVariables>({
          query: exportSubscription,
          variables: this.variables,
        })
        .map(({ data }) => (data?.spot ?? undefined) as SpotsExportSpot)
        .filter(isDef)
        .reduce((spots, spot) => (spots.push(spot), spots), new Array<SpotsExportSpot>())
        .subscribe(resolve);
    });
  }
}
